import React from 'react';

const ProgressView = () => {
  return (
    <div className="LTSPageCommon-ProgressView-wrapper">
      <span className="LTSPageCommon-ProgressView-spinner" />
    </div>
  );
};

export default ProgressView;
